import { PatternFormat } from 'react-number-format';
import { Spinner } from '../../ui/Spinner/Spinner';
import Container from '../../ui/Container/Container';
import styles from './UserQuickAdd.module.css';
import useUserQuickAdd from './useUserQuickAdd';
import { AlertMessage } from '../../ui/AlertMessage/AlertMessage';
import { Helpers } from '../../../utils/helpers';
import { AlertStatus } from '../../ui/AlertMessage/AlertStatus';

interface UserQuickAddProps {
  visible?: boolean;
  onCancel?: (() => void) | undefined;
  onUserAdded: (userId: string) => void;
}

export const UserQuickAdd = ({ visible = true, onUserAdded, onCancel }: UserQuickAddProps) => {
  const manager = useUserQuickAdd(onUserAdded, onCancel);

  if (!visible) return <></>;

  return (
    <div>
      <h4>Add New User</h4>
      <AlertMessage
        status={AlertStatus.ERROR}
        message={manager.alertMessage}
        visible={!Helpers.isNullOrWhiteSpace(manager.alertMessage)}
      />
      <div className="form-group">
        <div>
          <label htmlFor="emailAddress">Email Address</label>
          <input
            type="email"
            id="emailAddress"
            maxLength={65}
            className={`form-control ${
              manager.fieldErrors.includes('overview:emailAddress') ? 'is-invalid' : ''
            }`}
            value={manager.userAddRequest.emailAddress}
            onChange={(e: React.FormEvent<HTMLInputElement>) => {
              manager.updateValue('emailAddress', e.currentTarget.value);
            }}
          />
        </div>
        <div className="row mt-3">
          <div className="col-lg-6 col-md-12">
            <div className="mb-3">
              <label htmlFor="firstName">First Name</label>
              <input
                type="text"
                id="firstName"
                maxLength={65}
                className={`form-control ${
                  manager.fieldErrors.includes('overview:firstName') ? 'is-invalid' : ''
                }`}
                value={manager.userAddRequest.firstName}
                onChange={(e: React.FormEvent<HTMLInputElement>) => {
                  manager.updateValue('firstName', e.currentTarget.value);
                }}
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="mb-3">
              <label htmlFor="firstName">Last Name</label>
              <input
                type="text"
                id="lastName"
                maxLength={65}
                className={`form-control ${
                  manager.fieldErrors.includes('overview:lastName') ? 'is-invalid' : ''
                }`}
                value={manager.userAddRequest.lastName}
                onChange={(e: React.FormEvent<HTMLInputElement>) => {
                  manager.updateValue('lastName', e.currentTarget.value);
                }}
              />
            </div>
          </div>
        </div>
        <div>
          <label htmlFor="cellPhone">Cell Phone (optional)</label>
          <PatternFormat
            id="cellPhone"
            maxLength={15}
            className={`form-control ${
              manager.fieldErrors.includes('overview:cellPhone') ? 'is-invalid' : ''
            }`}
            format="(###) ### ####"
            mask="_"
            value={manager.userAddRequest.cellPhone}
            onChange={(e: React.FormEvent<HTMLInputElement>) => {
              manager.updateValue('cellPhone', e.currentTarget.value);
            }}
          />
        </div>
        <div className="form-check mt-3">
          <input
            id="sendFirstTimeEmail"
            className="form-check-input"
            type="checkbox"
            onChange={() => manager.toggleSendFirstTimeEmail()}
            checked={manager.userAddRequest.sendFirstTimeEmail}
          />
          <label className="form-check-label" htmlFor="sendFirstTimeEmail">
            Send first time setup email to user.
          </label>
        </div>
      </div>
      <Container className={styles.actionButtons} visible={onCancel !== undefined}>
        <button
          className="btn btn-primary"
          onClick={() => {
            if (onCancel) onCancel();
          }}>
          Cancel
        </button>
        <button
          className="btn btn-primary"
          onClick={manager.saveChanges}
          disabled={manager.isSaving}>
          Create User
          {manager.isSaving && <Spinner size="sm" className="ms-2" />}
        </button>
      </Container>
    </div>
  );
};
